import { notamParser } from "./Notam/NotamDecoder";
import { metarParser, tafParser } from "./MetarTaf/MetarTafDecoder";
import { snowtamParser } from "./Snowtam/SnowtamDecoder";
import { sigmetParser } from "./Sigmet/SigmetDecoder";
import { airepParser } from "./Airep/AirepDecoder";

export {
  ENotamScheduleStates,
  notamScheduleStatus,
  INotamRepeatSchedule,
  parseNotamSchedule,
} from "./Notam";

export const Decoder = () => {
  return {
    notam: notamParser,
    metar: metarParser,
    taf: tafParser,
    snowtam: snowtamParser,
    sigmet: sigmetParser,
    airep: airepParser,
  };
};
export default Decoder;
